// Module
var code = "<div layout=\"column\" class=\"full-height br-body-2\"> <fulfillment-map steps=\"$ctrl.fulfillmentSteps\" service-areas=\"$ctrl.serviceAreas\"></fulfillment-map> </div> ";
// Exports
export default code;